export default [
    {
        path: "/contract-management/review-awarded-contracts",
        name: "review-awarded-contracts",
        meta: {
            title: "Review Awarded Contracts",
            authRequired: true,
            /*  privileges: [
                  'ROLE_PRIVILEGE_HERE',
              ]*/
        },
        component: () => import("../views/contract-management/review-awarded-contracts.vue"),
    },
    {
        path: "/contract-management/contract-review",
        name: "contract-review",
        meta: {
            title: "list contracts workspace",
            authRequired: true,
            /*  privileges: [
                   'ROLE_PRIVILEGE_HERE',
               ]*/
        },
        component: () => import("../views/contract-management/contract-review.vue"),
    },
    {
        path: "/contract-management/list-awarded-contracts",
        name: "list-contracts",
        meta: {
            title: "awarded contracts",
            authRequired: true,
          /*  privileges: [
                'ROLE_PRIVILEGE_HERE',
            ]*/
        },
        component: () => import("../views/contract-management/list-awarded-contracts.vue"),
    },
    {
        path: "/contract-management/create-contract-workspace",
        name: "create-workspace",
        meta: {
            title: "create contract workspace",
            authRequired: true,
            /*  privileges: [
                   'ROLE_PRIVILEGE_HERE',
               ]*/
        },
        component: () => import("../views/contract-management/create-contracts-workspace.vue"),
    },
    {
        path: "/contract-management/manage-contracts-workspace",
        name: "manage-contracts",
        meta: {
            title: "manage contracts workspace",
            authRequired: true,
            /*  privileges: [
                   'ROLE_PRIVILEGE_HERE',
               ]*/
        },
        component: () => import("../views/contract-management/manage-contracts-workspace.vue"),
    },
    {
        path: "/contract-management/list-contracts-workspace",
        name: "list-contracts-workspace",
        meta: {
            title: "list contracts workspace",
            authRequired: true,
            /*  privileges: [
                   'ROLE_PRIVILEGE_HERE',
               ]*/
        },
        component: () => import("../views/contract-management/list-contracts-workspace.vue"),
    },
    {
        path: "/contract-management/list-shared-workspaces",
        name: "list-shared-contract-workspace",
        meta: {
            title: "list shared contracts workspace",
            authRequired: true,
            /*  privileges: [
                   'ROLE_PRIVILEGE_HERE',
               ]*/
        },
        component: () => import("../views/contract-management/list-contracts-shared-workspace.vue"),
    },
    {
        path: "/contract-management/view-contract-workspace",
        name: "view-contract-workspace",
        meta: {
            title: "list contracts workspace",
            authRequired: true,
            /*  privileges: [
                   'ROLE_PRIVILEGE_HERE',
               ]*/
        },
        component: () => import("../views/contract-management/view-workspace.vue"),
    },
    {
        path: "/contract-management/submitted-milestones",
        name: "view-submitted-milestone",
        meta: {
            title: "list submitted milestone",
            authRequired: true,
            /*  privileges: [
                   'ROLE_PRIVILEGE_HERE',
               ]*/
        },
        component: () => import("../views/contract-management/list-submitted-milestones.vue"),
    },
    {
        path: "/contract-management/milestone-review",
        name: "milestone-review",
        meta: {
            title: "milestone review",
            authRequired: true,
            /*  privileges: [
                   'ROLE_PRIVILEGE_HERE',
               ]*/
        },
        component: () => import("../views/contract-management/milestone-review.vue"),
    },

    {
        path: "/contract-management/termination-requests",
        name: "view-termination-requests",
        meta: {
            title: "list termination requests",
            authRequired: true,
            /*  privileges: [
                   'ROLE_PRIVILEGE_HERE',
               ]*/
        },
        component: () => import("../views/contract-management/contract-termination-request.vue"),
    },

    {
        path: "/contract-management/terminated-contract",
        name: "terminated-contracts",
        meta: {title: "Terminated Contracts", authRequired: false},
        component: () => import("../views/contract-management/terminated-contracts.vue"),
    },

    {
        path: "/contract-management/contract-closure-requests",
        name: "contract-closure-requests",
        meta: {title: "Contract Closure Requests", authRequired: false},
        component: () => import("../views/contract-management/contract-closure-requests.vue"),
    },
    {
        path: "/contract-management/completed-contracts",
        name: "completed-contracts",
        meta: {title: "Completed Contracts", authRequired: false},
        component: () => import("../views/contract-management/completed-contracts.vue"),
    },

    {
        path: "/contract-management/running-contracts",
        name: "running-contracts",
        meta: {title: "Active Contracts", authRequired: false},
        component: () => import("../views/contract-management/list-running-contracts.vue"),
    },
]